import { render, staticRenderFns } from "./GbNavbar.vue?vue&type=template&id=9436bd3c&scoped=true"
import script from "./GbNavbar.vue?vue&type=script&lang=js"
export * from "./GbNavbar.vue?vue&type=script&lang=js"
import style0 from "./GbNavbar.vue?vue&type=style&index=0&id=9436bd3c&prod&lang=less"
import style1 from "./GbNavbar.vue?vue&type=style&index=1&id=9436bd3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9436bd3c",
  null
  
)

export default component.exports